import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full bg-[#f0f7ff] shadow-sm" data-id="element-94">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-95">
        <div className="flex items-center" data-id="element-96">
          <Link to="/" data-id="element-97">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tZt8Y24BXXUUFMEFqS2eFe/sport-pro-04-min_2.png" alt="SportProZ Logo" className="h-10 md:h-12" data-id="element-98" />
          </Link>
        </div>
        <div className="hidden md:flex items-center space-x-6" data-id="element-99">
          <a href="#features" className="text-gray-800 hover:text-blue-500 font-medium" data-id="element-100">
            Features
          </a>
          <a href="#contact" className="text-gray-800 hover:text-blue-500 font-medium" data-id="element-101">
            Contact
          </a>
          <a href="#about" className="text-gray-800 hover:text-blue-500 font-medium" data-id="element-102">
            About
          </a>
          <a href="#global" className="text-gray-800 hover:text-blue-500 font-medium" data-id="element-103">
            Global Reach
          </a>
          <Link to="/login" className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-md transition-colors" data-id="element-104">
            Login
          </Link>
        </div>
        <div className="md:hidden" data-id="element-105">
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-800" data-id="element-106">
            {isOpen ? <X size={24} data-id="element-107" /> : <Menu size={24} data-id="element-108" />}
          </button>
        </div>
      </div>
      {isOpen && <div className="md:hidden bg-white px-4 py-2 shadow-md" data-id="element-109">
          <div className="flex flex-col space-y-3" data-id="element-110">
            <a href="#features" className="text-gray-800 hover:text-blue-500 font-medium" onClick={() => setIsOpen(false)} data-id="element-111">
              Features
            </a>
            <a href="#contact" className="text-gray-800 hover:text-blue-500 font-medium" onClick={() => setIsOpen(false)} data-id="element-112">
              Contact
            </a>
            <a href="#about" className="text-gray-800 hover:text-blue-500 font-medium" onClick={() => setIsOpen(false)} data-id="element-113">
              About
            </a>
            <a href="#global" className="text-gray-800 hover:text-blue-500 font-medium" onClick={() => setIsOpen(false)} data-id="element-114">
              Global Reach
            </a>
            <Link to="/login" className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-md transition-colors inline-block text-center" onClick={() => setIsOpen(false)} data-id="element-115">
              Login
            </Link>
          </div>
        </div>}
    </header>;
}